import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '@/components/feature/BottomNav';
import DataCards from './components/DataCards';
import RecommendCard from './components/RecommendCard';
import QuickFocus from './components/QuickFocus';
import TodoList from './components/TodoList';
import { mockStats, mockGrowthRecords } from '@/mocks/userData';

const greetings = [
  '下午好，开始你的轻盈时光',
  '今天也是全新的一天',
  '轻轻出发，慢慢成长',
  '每一步都算数',
];

function getGreeting() {
  const h = new Date().getHours();
  if (h < 6) return '深夜了，注意休息';
  if (h < 12) return '早上好，开始你的轻盈时光';
  if (h < 18) return '下午好，开始你的轻盈时光';
  return '晚上好，今天辛苦了';
}

function getDateStr() {
  const d = new Date();
  const months = d.getMonth() + 1;
  const days = d.getDate();
  const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
  return `${months}月${days}日 周${weekDays[d.getDay()]}`;
}

export default function HomePage() {
  const navigate = useNavigate();
  const [selectedFocus, setSelectedFocus] = useState(25);
  const [showRefresh, setShowRefresh] = useState(false);
  const [refreshMsg, setRefreshMsg] = useState('');

  const todayPhotos = mockGrowthRecords.filter(r => r.date === '2026-04-19').reduce((acc, r) => acc + r.photos.length, 0);

  const handleRefresh = () => {
    const msg = greetings[Math.floor(Math.random() * greetings.length)];
    setRefreshMsg(msg);
    setShowRefresh(true);
    setTimeout(() => setShowRefresh(false), 2500);
  };

  return (
    <div className="h-full flex flex-col relative" style={{ background: '#F5F7FA', fontFamily: '\'Noto Sans SC\', sans-serif' }}>
      <div className="flex-1 overflow-y-auto relative" style={{ scrollbarWidth: 'none' }}>
        {/* 背景弥散光 — 蓝紫色 */}
        <div
          className="absolute top-0 left-0 right-0 h-72 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(181,198,224,0.2) 0%, transparent 80%)' }}
        />

        {showRefresh && (
          <div
            className="absolute top-4 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded-full text-sm"
            style={{ background: 'rgba(255,255,255,0.92)', color: '#A8B8D8', backdropFilter: 'blur(8px)', border: '1px solid rgba(181,198,224,0.3)' }}
          >
            {refreshMsg}
          </div>
        )}

        {/* Header */}
        <div className="flex items-center justify-between px-4 pt-12 pb-5">
          <div>
            <p className="font-semibold text-base" style={{ color: '#2D2B3D' }}>{getGreeting()}</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm" style={{ color: '#8E8E93' }}>{getDateStr()}</span>
            <button onClick={handleRefresh} className="w-8 h-8 flex items-center justify-center cursor-pointer">
              <i className="ri-notification-3-line text-lg" style={{ color: '#C5B9D8' }} />
            </button>
          </div>
        </div>

        <DataCards
          focusMinutes={mockStats.todayFocusMinutes}
          habitDone={mockStats.habitProgress.done}
          habitTotal={mockStats.habitProgress.total}
        />
        <RecommendCard />
        <QuickFocus selected={selectedFocus} onSelect={setSelectedFocus} />
        <TodoList />

        {/* 成长记录快捷入口 */}
        <div className="px-4 mt-3 mb-4">
          <button
            onClick={() => navigate('/growth')}
            className="w-full flex items-center gap-3 px-4 py-3.5 rounded-2xl cursor-pointer active:scale-95 transition-transform"
            style={{
              background: 'rgba(197,185,216,0.15)',
              border: '1px solid rgba(181,198,224,0.25)',
              backdropFilter: 'blur(12px)',
            }}
          >
            <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'linear-gradient(135deg,#B5C6E0,#C5B9D8)' }}>
              <i className="ri-camera-line text-white text-base" />
            </div>
            <div className="flex-1 text-left">
              <p className="text-sm font-medium" style={{ color: '#A8B8D8' }}>记录今天的进步</p>
              <p className="text-xs mt-0.5" style={{ color: '#C5B9D8' }}>用照片留住每一个成长瞬间</p>
            </div>
            <div className="flex items-center gap-1.5">
              {todayPhotos > 0 && (
                <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(181,198,224,0.2)', color: '#A8B8D8' }}>
                  今日{todayPhotos}张
                </span>
              )}
              <i className="ri-arrow-right-s-line" style={{ color: '#C5B9D8' }} />
            </div>
          </button>
        </div>

        <div className="pb-4" />
      </div>

      <BottomNav />
    </div>
  );
}
